import type { WidgetPreset } from "../types";
import { MusicWidget, SOMA_STATIONS } from "./MusicWidget";
import previewTemplateHtml from "./preview.template.html?raw";

/**
 * Music player widget — rendered as a React component (MusicWidget.tsx).
 *
 * Streams SomaFM internet radio stations (free, no auth required).
 * Station selection is synced via Loro; playback state is local per-user.
 *
 * generateMusicPreviewHtml is used ONLY for the static thumbnail in the
 * widget selector. The live canvas node is handled by MusicWidget.
 */

function generateMusicPreviewHtml(): string {
  const station = SOMA_STATIONS[2]; // Secret Agent (Lounge · Jazz)

  const dots = Array.from({ length: 54 }, (_, i) => {
    const row = Math.floor(i / 9);
    const col = i % 9;
    const edgeDist = Math.min(row, 5 - row, col, 8 - col);
    const op = edgeDist === 0 ? 0.22 : edgeDist === 1 ? 0.38 : 0.55;
    return `<div style="width:4px;height:4px;border-radius:50%;background:rgba(255,255,255,${op})"></div>`;
  }).join("");

  return previewTemplateHtml
    .replaceAll("__STATION_COLOR__", station.color)
    .replaceAll("__STATION_EMOJI__", station.emoji)
    .replaceAll("__STATION_LABEL__", station.label)
    .replaceAll("__STATION_DESC__", station.desc)
    .replaceAll("__DOTS__", dots);
}

export const MUSIC_PLAYER: WidgetPreset = {
  id: "music-player",
  label: "Radio Player 🎵",
  defaultWidth: 296,
  defaultHeight: 220, // includes controls row; actual height measured by ReactWidgetShell
  component: MusicWidget,
  resizable: { minWidth: 160, minHeight: 108 }, // ~50% of natural size
  previewScale: 0.4, // 220 * 0.40 = 88px visual height fits within 96px container
  previewHtml: generateMusicPreviewHtml(),
  initialData: { stationIndex: 2 }, // Secret Agent default
};
